exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#page-header-back-button{\nbutton.go-back{\n    margin-top: 0 !important;\n}\n}\n", ""]);

// exports
